import { APP_NAME, RequestMethod } from '~/shared/constants/commonConstants'
import { ApiService } from '~/shared/services/api'
import { IRequestOptions, IResponseResult } from '~/shared/types/apiTypes'
import { IRawVariant } from '~/shared/types/variantTypes'

export class VariantsApi {
  private api: ApiService

  constructor(api: ApiService) {
    this.api = api
  }

  getVariant({
    cohort,
  }: {
    cohort: string
  }): Promise<IResponseResult<IRawVariant>> {
    const options: IRequestOptions = {
      method: RequestMethod.GET,
      params: { cohort },
    }

    return this.api.makeRequest<IRawVariant>(
      `v1/flow/${APP_NAME}/variants`,
      options,
    )
  }
}
